import React from "react";

import AutoOrderAccountSetupModal from "@/components/auto-order/autoOrderAccountSetupModal";
import Toast from "@/components/design-system/toast";

const AutoOrderModals = ({
  showCompleteSetupModal,
  showAddedToAutoOrderModal,
  showCompleteSetupModalCb,
  showAddedToAutoOrderModalCb,
  missingShippingInfo,
  missingBillingInfo,
  missingLicenses,
  productTitle,
}: AutoOrderModalsProps) => {
  return (
    <React.Fragment>
      <AutoOrderAccountSetupModal
        show={showCompleteSetupModal}
        onHide={() => showCompleteSetupModalCb(false)}
        missingBillingInfo={missingBillingInfo}
        missingShippingInfo={missingShippingInfo}
        missingLicenses={missingLicenses}
      />
      <ProductAddedToAutoOrderToast
        showAddedToAutoOrderModal={showAddedToAutoOrderModal}
        showAddedToAutoOrderModalCb={showAddedToAutoOrderModalCb}
        productTitle={productTitle}
      />
    </React.Fragment>
  );
};

const ProductAddedToAutoOrderToast = ({
  showAddedToAutoOrderModal,
  showAddedToAutoOrderModalCb,
  productTitle,
}: ProductAddedProps) => {
  return (
    <Toast
      toastMessage="Item Added to Auto Order"
      toastSubMessage={`"${productTitle}" has been added to your Auto Order.`}
      linkText="Edit Auto Order"
      linkHref="/account/orders/auto-order"
      showToast={showAddedToAutoOrderModal}
      toastType="success"
      hideToast={() => {
        showAddedToAutoOrderModalCb(false);
        return { type: "productAddedToAutoOrderToast/hide", payload: undefined };
      }}
      showCloseButton
      showLinkCaret={false}
      showOnMobile
      showToastTime={6000}
      toastLocation="top"
    />
  );
};

export default AutoOrderModals;

interface AutoOrderModalsProps extends CompleteSetupProps, ProductAddedProps {}

interface CompleteSetupProps {
  showCompleteSetupModal: boolean;
  showCompleteSetupModalCb: React.Dispatch<React.SetStateAction<boolean>>;
  missingShippingInfo: boolean;
  missingBillingInfo: boolean;
  missingLicenses: boolean;
}

interface ProductAddedProps {
  showAddedToAutoOrderModal: boolean;
  showAddedToAutoOrderModalCb: React.Dispatch<React.SetStateAction<boolean>>;
  productTitle: string;
}
